import { useEventbriteUrl } from '@/common/constants/useEventbriteUrl';
import homeStyles from '@/styles/Home.module.css';
import { Button, Typography } from '@eventbrite/marmalade';
import Link from 'next/link';
import React from 'react';
import ContactOrganizerInstructions from '../ContactOrganizer/ContactOrganizerInstructions/ContactOrganizerInstructions';
import TextDivider from '../Divider/TextDivider';
import { PageTitle } from '../Layout/LeftPane/PageTitle';
import styles from './InputsDontMatch.module.scss';

interface InputsDontMatchProps {
  onTryAgainClick: () => void;
}

export const InputsDontMatch: React.FC<InputsDontMatchProps> = ({ onTryAgainClick }) => {
  const CONTACT_ORGANIZER_URL = useEventbriteUrl('CONTACT_ORGANIZER_URL');
  return (
    <>
      <PageTitle pageTitle={'Inputs don’t match'} />
      <div className={styles['inputs-dont-match-container']}>
        <div className={styles['inputs-dont-match-content']}>
          <Typography>
            That information does not match the order on file. You can{' '}
            <Link href={CONTACT_ORGANIZER_URL} target="_blank" passHref className={homeStyles.url}>
              contact the event organizer
            </Link>{' '}
            or try again.
          </Typography>
          <Button
            variant="secondary"
            className={styles['inputs-dont-match-button']}
            onClick={onTryAgainClick}
            data-heap-id="inputs_dont_match_try_again"
          >
            Try again
          </Button>
          <TextDivider text="or" />
          <ContactOrganizerInstructions />
        </div>
      </div>
    </>
  );
};
